import React from "react";
import BookCard from "./BookCard";
import BookFilter from "./BookFilter";
import { useGetBooksQuery } from "../../features/API/apiSlice";
import Loader from "../../components/ui/loaders/Loader";
import Error from "../../components/ui/Error";
import { useSelector } from "react-redux";

export default function BookContainer() {
  const { filter, search } = useSelector((state) => state.filter);

  const { data: books, isLoading, isError } = useGetBooksQuery();

  // BOOK CARD
  let contentOfBookCard = null;
  if (isLoading) {
    contentOfBookCard = <Loader />;
  }
  if (!isLoading && isError) {
    contentOfBookCard = <Error message="There was an error 🔴🔴" />;
  }
  if (!isLoading && !isError && books.length === 0) {
    contentOfBookCard = <Error message="No Books found!" />;
  }
  if (!isLoading && !isError && books.length > 0) {
    let newBooks = [...books];
    if (filter === "Featured") {
      newBooks = books.filter((book) => book.featured === true);
    }

    if (search !== "") {
      // newBooks = books.filter((book) =>
      //   book.name.toLowerCase().includes(search.toLowerCase())
      // );

      newBooks =
      newBooks?.length > 0
        ? newBooks.filter((book) =>
            book.name.toLowerCase().includes(search.toLowerCase())
          )
        : books.filter((book) =>
            book.name.toLowerCase().includes(search.toLowerCase())
          );
    }

    if (newBooks.length > 0) {
      contentOfBookCard = newBooks.map((book, index) => (
        <BookCard key={`${book.id}_${index}`} book={book} />
      ));
    } else {
      contentOfBookCard = (
        <Error message="No books found matching your search criteria." />
      );
    }
  }
  // BOOK CARD---------

  return (
    <main className="py-12 px-6 2xl:px-6 container">
      <div className="order-2 xl:-order-1">
        <div className="flex items-center justify-between mb-12">
          <h4 className="mt-2 text-xl font-bold">Book List</h4>
          <BookFilter />
        </div>
        <div className="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
          {contentOfBookCard}
        </div>
      </div>
    </main>
  );
}
